import { useEffect, useMemo, useRef, useState } from 'react';
import { toTitleFromFileName } from './aiUtils';

export default function AiVideoCard({ src, fileName, className = '' }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const title = useMemo(() => toTitleFromFileName(fileName, src), [fileName, src]);

  useEffect(() => {
    const videoEl = videoRef.current;
    if (!videoEl) return;

    // Ensure no controls + no preload issues
    videoEl.controls = false;
    videoEl.preload = 'metadata';
    videoEl.muted = false;
    // NOTE: still no autoplay

    return () => {
      try {
        videoEl.pause();
      } catch (_) {}
    };
  }, []);

  const play = async () => {
    const videoEl = videoRef.current;
    if (!videoEl) return;
    try {
      // Resume from last position
      await videoEl.play();
      setIsPlaying(true);
    } catch (e) {
      // Autoplay restrictions can block. We silently ignore.
      setIsPlaying(false);
    }
  };

  const pause = () => {
    const videoEl = videoRef.current;
    if (!videoEl) return;
    try {
      videoEl.pause();
      setIsPlaying(false);
    } catch (_) {}
  };

  return (
    <div className={`ai-card ai-video-card ${className}`.trim()}>
      <div
        className="ai-video-viewport"
        onMouseEnter={() => {
          // Desktop hover play only if user has a pointer/hover capability
          if (window.matchMedia && window.matchMedia('(hover: hover)').matches) play();
        }}
        onMouseLeave={() => {
          if (window.matchMedia && window.matchMedia('(hover: hover)').matches) pause();
        }}
        onClick={() => {
          // Mobile click play
          if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return;
          if (isPlaying) pause();
          else play();
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            play();
          }
        }}
      >
        <video
          ref={videoRef}
          src={src}
          playsInline
          // no controls; keep it hidden
          controls={false}
          // Never autoplay
          autoPlay={false}
        />
      </div>
      <div className="ai-caption">{title}</div>
    </div>
  );
}

